import asyncSessionLoader from "../../gd/data/async-session-loader"

const debug = {
    dev: false,
    head: "Project Loaded"
}

export default class ProjectLoader {

    public projectId    : ID
    public project      : any
    public notFound     : boolean = false
    public errorLoading : boolean = false
    public isLoading    : boolean = false // shows if loading is required (and we need to show loading screen)
    public isLoaded     : Promise<boolean> = new Promise((resolve, reject)=>{})

    private onResolve    : any

    constructor(projectId: ID) {
        this.projectId      = projectId

        this.load()
    }

    // return true if loaded otherwise loading promise
    load() {

        this.isLoaded = new Promise((resolve, reject)=>{this.onResolve = resolve})

        // make sure project in session
        this.project = gd.session.projects.get(this.projectId)

        if (!this.project) {
            this.isLoading = true
            this._loadArchivedProject()
        } else {
            this._loadSettings()
        }

        // so we could do inline new class & load
        return this;
    }

    _getProjectsIdsWeNeedToLoadSettingsFor() {

        const result = [];

        // check project itself
        if (_.isNil(this.project.settings)) result.push(this.project.id);

        // check parents
        _.map(gd.session.projects.getAllParents(this.project.id),parentProject=>{
            if (_.isNil(parentProject.settings)) result.push(parentProject.id)
        })

        return result
    }

    async _loadSettings() {

        if (debug.dev) console.log(debug.head, "_loadSettings")

        const projectIds = this._getProjectsIdsWeNeedToLoadSettingsFor()

        if (projectIds.length>0) {
            if (debug.dev) console.log(debug.head, "need to load settings for", projectIds);

            this.isLoading = true;

            try {
                await asyncSessionLoader(gd.session.findMissing({
                    projectsSettings: projectIds,
                    // projectsWithParents: [this.project.id], //required to have all parent projects in session even with no access (for properties inheritance)
                }))
                this._finalize()
            } catch (error) {
                this._finalizeWithError(error)
            }
        } else {
            this._finalize()
        }
    }

    async _loadArchivedProject() {

        if (debug.dev) console.log(debug.head, "_loadArchivedProject");

        try {
            await gd.api.Project.loadArchived(this.projectId).promise()
            if (debug.dev) console.log("archived project loaded")
            this.project = gd.session.projects.get(this.projectId)
            this._loadSettings()
        } catch(error: any) {
            this.notFound = true
            // prevent default error message
            if (error.code === 403 || error.code === 404) {
                gd.growl.removeAll()
            }
            this._finalizeWithError(error)
        }
    }

    _finalizeWithError(error: any) {
        // this.errorLoading
        this.onResolve()
    }

    _finalize() {
        if (debug.dev) console.log(debug.head, "_finalize")

        this.onResolve()
    }
}
